<template>
  <div class="sale-pay"></div>
</template>
<script>
import _wx from "../../static/js/chelun-wx-1.1.js";
import _kjz from "../../static/js/chelun-kjz.js";
import { cjjlPay, OPENIDNEW, hostUrl, OPENID } from "../http/env.js";
import { pay } from "@/http/api";

export default {
  data() {
    return {
      paySubmit: {
        openid: "",
        c: "order",
        v: "pay2",
        serial_number: this.$route.query.serial_number || "",
        channel: "",
        callback_url: this.$route.query.callback_url
          ? decodeURIComponent(this.$route.query.callback_url)
          : "",
      },
    };
  },
  methods: {
    payHandle() {
      pay({ ...this.paySubmit }).then((res) => {
        console.log(res);
        if (_wx.isWx) {
          if (this.$route.query.payFrom) {
            let path = cjjlPay + "/2017/superCoach/pay_wx.html";
            let i,
              url = "";
            for (i in res.data.order_param) {
              url += "&" + i + "=" + res.data.order_param[i];
            }
            window.location.href = path + url.replace(/./, "?");
          } else {
            _wx.pay(res.data.order_param, () => {
              window.location.href = res.data.order_param.callback_url;
            });
          }
        } else {
          window.location.href = res.data.url;
        }
      });
    },
    init() {
      if (_wx.isWx) {
        this.paySubmit.openid = this.$route.query.openid || "";
        if (!this.paySubmit.openid) {
          this.getOpenIdNew();
          return false;
        }
      }
      this.paySubmit.channel = _wx.isWx ? "weixin_mp" : "alipay";
      this.payHandle();
    },
    // 车轮驾考通app获取openid
    getOpenIdNew() {
      var url = window.location.href;
      var href = `${OPENIDNEW}/xc_v1/Wechat/getOpenId?source=` + encodeURIComponent(url);
      window.location.href = href;
    },
  },
  created() {
    this.init();
    window["CHELUN_SHOW_OPTION_MENU"] = 0;
    _wx.hideMenus([
      "menuItem:share:appMessage",
      "menuItem:share:timeline",
      "menuItem:share:qq",
      "menuItem:share:weiboApp",
      "menuItem:favorite",
      "menuItem:share:facebook",
      "menuItem:share:QZone",
      "menuItem:copyUrl",
    ]);
  },
};
</script>

<style lang="scss" scoped>
.sale-pay {
  font-size: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/sale-pay.vue